import { createStandardAction, getType, ActionType } from 'typesafe-actions';

import { RootAction } from '../../RootAction';

const OPEN_NAV = 'PeeringWeb/Nav/OPEN_NAV';
const CLOSE_NAV = 'PeeringWeb/Nav/CLOSE_NAV';
const TOGGLE_NAV = 'PeeringWeb/Nav/TOGGLE_NAV';
const SET_SCROLLED = 'PeeringWeb/Nav/SET_SCROLLED';
const OPEN_SUBMENU = 'PeeringWeb/Nav/OPEN_SUBMENU';
const CLOSE_SUBMENU = 'PeeringWeb/Nav/CLOSE_SUBMENU';

export const openNav = createStandardAction(OPEN_NAV)();
export const closeNav = createStandardAction(CLOSE_NAV)();
export const toggleNav = createStandardAction(TOGGLE_NAV)();
export const setScrolled = createStandardAction(SET_SCROLLED)<boolean>();
export const openSubMenu = createStandardAction(OPEN_SUBMENU)<string | null>();
export const closeSubMenu = createStandardAction(CLOSE_SUBMENU)();

export type Actions =
  | ActionType<typeof openNav>
  | ActionType<typeof closeNav>
  | ActionType<typeof toggleNav>
  | ActionType<typeof setScrolled>
  | ActionType<typeof openSubMenu>
  | ActionType<typeof closeSubMenu>;

export interface NavState {
  isOpened: boolean;
  isScrolled: boolean;
  openedSubMenu: string | null;
}

const defaultState: NavState = {
  isOpened: false,
  isScrolled: false,
  openedSubMenu: null,
};

export default (state: NavState = defaultState, action: RootAction) => {
  switch (action.type) {
    case getType(openNav):
      return {
        ...state,
        isOpened: true,
      };
    case getType(closeNav):
      return {
        ...state,
        isOpened: false,
      };
    case getType(toggleNav):
      return {
        ...state,
        isOpened: !state.isOpened,
      };
    case getType(setScrolled):
      return {
        ...state,
        isScrolled: action.payload,
      };
    case getType(openSubMenu):
      return {
        ...state,
        openedSubMenu: action.payload,
      };
    case getType(closeSubMenu):
      return {
        ...state,
        openedSubMenu: null,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// /www/client/src/containers/Nav/navDuck.ts